module.exports = __webpack_public_path__ + "media/home/hero-dae6dc57.png";